import { useMutation } from '@tanstack/react-query';
import { updateProjectKeywords } from '../../../services/project/options/ProjectOptionsService';

export const useUpdateProjectOptionsKeywords = () => {
  const mutation = useMutation<boolean, Error, { projectId: number; keywords: string[] }>({
    mutationFn: ({ projectId, keywords }) => updateProjectKeywords(projectId, keywords),
  });

  return mutation;
};
